import React from 'react';
import { useTranslation } from '../../../shared/i18n';
import * as S from '../Conecta2ProductPage.styles';

const HeroSection = ({ image, imageAlt }) => {
  const t = useTranslation();
  
  return (
    <S.HeroSection>
      <S.HeroBackground />
      <S.HeroContent>
        <S.HeroTitle>{t('conecta2Product.hero.title')}</S.HeroTitle>
        <S.HeroSubtitle>{t('conecta2Product.hero.subtitle')}</S.HeroSubtitle>
        <S.HeroImageContainer>
          <S.HeroImage 
            src={image} 
            alt={imageAlt}
            loading="eager"
          />
        </S.HeroImageContainer>
      </S.HeroContent>
    </S.HeroSection>
  );
};

export default HeroSection;
